import { render } from "./EDADashboard.vue?vue&type=template&id=1ed96d0d&scoped=true"
import script from "./EDADashboard.vue?vue&type=script&lang=js"
export * from "./EDADashboard.vue?vue&type=script&lang=js"

import "./EDADashboard.vue?vue&type=style&index=0&id=1ed96d0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed96d0d"]])

export default __exports__